import type {
  InstantSearchResultsProductTypes,
  ProductTypes
} from 'modules/products'
import { convertKeysToCamelCase } from 'shared/utils/common'

const searchResultsMissingProperties: Partial<ProductTypes> = {
  ageLimitMet: undefined,
  tags: [],
  commercialTags: [],
  categoriesTree: [],
  specialOfferMaxQuantityPerSaleOrder: null,
  specialOfferTotalQuantityLimit: null,
  isFavourite: false,
  category: undefined,
  showRemainingSpecialOfferQuantity: false,
  multipacks: [],
  specialOfferEndsAt: null,
  hasAvailabilityPlan: false,
  weeklyAvailabilityPlan: null
}

export const normalizeInstantSearchResultsToProductTypes = (
  instantSearchResults: InstantSearchResultsProductTypes[]
): ProductTypes[] =>
  instantSearchResults.map(result => ({
    ...convertKeysToCamelCase<ProductTypes>(result),
    ...searchResultsMissingProperties
  }))

export const sanitizeAlgoliaProductSearchResults = (
  algoliaProductSearchResults: ProductTypes[]
): ProductTypes[] =>
  algoliaProductSearchResults.filter(
    result =>
      result.isAvailable &&
      result.imageUrl &&
      result.slug &&
      result.nameShort &&
      result.nameDescriptionShort
  )
